<button class="tag-pill"
        [ngClass]="{ 'active' : selected, 'hoverable' : clickable && !disabled }"
        [disabled]="disabled"
        (click)="clicked()">
    <ng-content *ngIf="!text"></ng-content>
    <ng-container *ngIf="text">{{text | lowercase | ucfirst}}</ng-container>
</button>
